export default __webpack_public_path__ + "static/media/1.b5f50ca7.jpg";